import { Box, Flex } from '@chakra-ui/react';
import { Tag, Text } from '@kula-ai/components';
import { File05, XClose } from '@kula-ai/icons-core';
import type { AttachmentChipsProps } from './Composer.types';
import type { ComposerAttachmentRejection } from './attachmentPolicy';

export const AttachmentChips = ({ files, onRemove }: AttachmentChipsProps) => {
  if (files.length === 0) return null;
  return (
    <Flex wrap="wrap" gap="6px">
      {files.map((file, idx) => (
        <Tag
          key={`${file.name}-${idx}`}
          variant="white"
          size="md"
          label={file.name}
          leftElement={<File05 size={16} />}
          rightElement={
            <Box
              as="button"
              type="button"
              aria-label={`Remove ${file.name}`}
              onClick={() => onRemove(idx)}
              display="inline-flex"
              cursor="pointer"
            >
              <XClose size={16} />
            </Box>
          }
        />
      ))}
    </Flex>
  );
};

export const RejectedFilesNote = ({
  rejections,
}: {
  rejections: ComposerAttachmentRejection[];
}) => {
  if (rejections.length === 0) return null;
  return (
    <Box data-test-id="composer-file-rejected" mt="4px">
      {rejections.map(({ file, reason, message }, index) => (
        <Text
          key={`${file.name}-${file.size}-${file.lastModified}-${reason}-${index}`}
          variant="small"
          className="text-error-600"
        >
          {message}
        </Text>
      ))}
    </Box>
  );
};
